module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-locale-provider', {
    attrs: {
      "locale": _vm.zh_CN
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66871b3e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/App.vue
// module id = 2384
// module chunks = 1